<template>
  <div></div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  created: function() {
    this.$store.dispatch('UserStore/logout')
  }
}
</script>

<style scoped></style>
